/**
 * Connection-lost overlay — covers the stage with a friendly "reconnecting"
 * banner whenever the WS drops. Hidden when the WS is open.
 */

export interface ConnectionLostHandle {
  el: HTMLDivElement;
  setVisible(v: boolean): void;
}

export function createConnectionLost(stage: HTMLElement): ConnectionLostHandle {
  const el = document.createElement('div');
  el.setAttribute('data-scene', 'connection_lost');
  el.setAttribute('data-testid', 'hr-connection-lost');
  el.style.cssText = `
    position: absolute; inset: 0;
    display: none;
    align-items: center; justify-content: center;
    background: rgba(0,0,0,0.85);
    color: #ef4444;
    font-family: 'Oswald', sans-serif;
    font-size: 48px;
    z-index: 100;
  `;
  el.textContent = 'Reconnecting…';
  stage.appendChild(el);
  return {
    el,
    setVisible(v) {
      el.style.display = v ? 'flex' : 'none';
    },
  };
}
